import { Box, Grid, Paper, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import CommonUtil from "../../Util/CommonUtils";
import { REACT_KEY_CONFIGURATION } from "../../actions/EndPoints";
import { default as CustomTextfeild } from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import { getAccountList } from "../../slices/DashboardPanel/DashboardPanelSlice";
import {
  createMobileKeyConfigurations,
  updateMobileConfigurations,
} from "../../slices/MobileKeyConfiguration/MobileKeyConfigurationSlice";

export default function CreateKeyConfiguration(props) {
  let history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [customerList, setCustomersList] = useState([]);
  const [keyConfigurationId, setKeyConfigurationId] = useState(null);
  const [customerCompanyName, setCustomerCompanyName] = useState("");
  const [numberOfDeviceCount, setNumberOfDeviceCount] = useState("");
  const [paging, setPaging] = useState({
    pageNumber: 1,
    pageSize: 50,
  });

  const [configurationPayload, setConfigurationPayload] = React.useState({
    customerId: "",
    pdfDetectorActivationKey: "",
    mrzDetectorActivationKey: "",
    pdfParserActivationKey: "",
    privateConstValParserKey: "",
    privateConstValScannerKey: "",
    numberOfDevices: 0,
    customerName: "",
    androidMRZDetectionActivationKey: "",
  });

  const [error, setError] = React.useState({
    customerId: false,
    pdfDetectorActivationKey: false,
    mrzDetectorActivationKey: false,
    pdfParserActivationKey: false,
    privateConstValParserKey: false,
    privateConstValScannerKey: false,
    numberOfDevices: false,
    androidMRZDetectionActivationKey: false,
  });

  const [accountState, setAccountState] = useState({
    type: "CUSTOMER",
    name: "",
  });

  const handleKeyFieldChange = (event) => {
    const name = event.target.name;
    if (name === "numberOfDevices") {
      const numericValue = parseInt(event.target.value, 10);
      setConfigurationPayload({
        ...configurationPayload,
        [name]: isNaN(numericValue) ? 0 : numericValue,
      });
    } else {
      setConfigurationPayload({
        ...configurationPayload,
        [name]: event.target.value,
      });
      setError({
        [name]: false,
      });
    }
  };

  useEffect(() => {
    if (props.location.state != null) {
      setConfigurationPayload({
        ...configurationPayload,
        id: props.location.state.params.id,
        customerId: props.location.state.params.customerId,
        pdfDetectorActivationKey:
          props.location.state.params.pdfDetectorActivationKey,
        pdfParserActivationKey:
          props.location.state.params.pdfParserActivationKey,
        mrzDetectorActivationKey:
          props.location.state.params.mrzDetectorActivationKey,
        privateConstValParserKey:
          props.location.state.params.privateConstValParserKey,
        privateConstValScannerKey:
          props.location.state.params.privateConstValScannerKey,
        numberOfDevices: props.location.state.params.numberOfDevices,
        customerName: props.location.state.params.customerName,
        androidMRZDetectionActivationKey:
          props.location.state.params.androidMRZDetectionActivationKey,
      });
      setCustomerCompanyName(props.location.state.params.customerName);
      setNumberOfDeviceCount(props.location.state.params.numberOfDevices);
      setKeyConfigurationId(props.location.state.params.id);
    }
  }, []);

  const handleCancel = () => {
    history.push({
      pathname: REACT_KEY_CONFIGURATION,
    });
  };

  const handleText = (event) => {
    let payload;
    payload = {
      cascadeLimit: 2,
      accountDTO: { ...accountState, name: event.target.value },
      page: paging,
    };
    dispatch(getAccountList(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4009" && data.data) {
          if (data.data.companies.length === 0) {
            Toast(t("CUSTOMER_EMPTY"), "error");
            return;
          }
          setCustomersList(data.data.companies);
        }
      });
  };

  const filterOptions = createFilterOptions({
    stringify: ({ name }) => `${name}`,
    limit: 1,
  });

  const handleSubmit = () => {
    if (props.location.state === undefined) {
      dispatch(createMobileKeyConfigurations(configurationPayload))
        .unwrap()
        .then((data) => {
          switch (data.code) {
            case "MSGS4027":
              Toast(data.message, "success");
              history.push(REACT_KEY_CONFIGURATION);
              break;
            case "MSGE4036":
              setError({
                ...error,
                customerId: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4037":
              setError({
                ...error,
                pdfDetectorActivationKey: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4038":
              setError({
                ...error,
                mrzDetectorActivationKey: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4039":
              setError({
                ...error,
                pdfParserActivationKey: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4040":
              setError({
                ...error,
                privateConstValParserKey: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4041":
              setError({
                ...error,
                privateConstValScannerKey: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4042":
              setError({
                ...error,
                numberOfDevices: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4049":
              Toast(data.message, "error");
              break;
            case "MSGE4198":
              setError({
                ...error,
                androidMRZDetectionActivationKey: true,
              });
              Toast(data.message, "error");
              break;
            default:
              Toast(data.message, "error");
              break;
          }
        })
        .catch((error) => {
          Toast(t("KEYCONFIGURATIONERROR"), "error");
        });
    } else {
      dispatch(updateMobileConfigurations(configurationPayload))
        .unwrap()
        .then((data) => {
          switch (data.code) {
            case "MSGS4055":
              Toast(data.message, "success");
              history.push(REACT_KEY_CONFIGURATION);
              break;
            case "MSGE4036":
              setError({
                ...error,
                customerId: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4037":
              setError({
                ...error,
                pdfDetectorActivationKey: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4038":
              setError({
                ...error,
                mrzDetectorActivationKey: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4039":
              setError({
                ...error,
                pdfParserActivationKey: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4040":
              setError({
                ...error,
                privateConstValParserKey: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4041":
              setError({
                ...error,
                privateConstValScannerKey: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4042":
              setError({
                ...error,
                numberOfDevices: true,
              });
              Toast(data.message, "error");
              break;
            case "MSGE4049":
              Toast(data.message, "error");
              break;
            case "MSGE4198":
              setError({
                ...error,
                androidMRZDetectionActivationKey: true,
              });
              Toast(data.message, "error");
              break;
            default:
              Toast(data.message, "error");
              break;
          }
        })
        .catch((error) => {
          Toast(t("KEYCONFIGURATIONERROR"), "error");
        });
    }
  };
  return (
    <>
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ m: 1.5, marginLeft: "1.5px" }}>
          <HeaderToolbar
            title={
              keyConfigurationId
                ? t("LABELNAVITEMSEDITKEY")
                : t("LABELNAVITEMSCREATEKEY")
            }
            back_button={true}
          />
        </Box>
      </Grid>
      <Paper
        style={{
          backgroundColor: "#fff",
          overflowX: "hidden",
          height: "calc(100vh - 180px)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box style={{ flex: 1 }}>
          <Grid
            container
            spacing={2}
            style={{
              padding: "20px",
              width: "100%",
            }}
          >
            <Grid item sm={4}>
              {keyConfigurationId ? (
                <CustomTextfeild
                  label={t("KEYCONFIGURATIONSEARCHCUSTOMER")}
                  value={customerCompanyName}
                  required={true}
                />
              ) : (
                <Autocomplete
                  disableClearable
                  popupIcon={<ExpandMoreIcon />}
                  id="free-solo-demo"
                  freeSolo
                  noOptionsText={"No Options found"}
                  fullWidth
                  filterOptions={filterOptions}
                  options={
                    CommonUtil.isEmptyArray(customerList) ? [] : customerList
                  }
                  getOptionLabel={(option) => option.name}
                  onChange={(event, newValue) => {
                    if (newValue === null) {
                      setConfigurationPayload({
                        ...configurationPayload,
                        customerId: "",
                      });
                      setCustomersList([]);
                    } else {
                      setConfigurationPayload({
                        ...configurationPayload,
                        customerId: newValue.id,
                        customerName: newValue.name,
                      });
                    }
                    setError({ customerId: false });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("KEYCONFIGURATIONSEARCHCUSTOMER")}
                      required={true}
                      placeholder={"Search..."}
                      name="customerId"
                      id="customerId"
                      error={error.customerId}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <InputAdornment position="end">
                              <IconButton
                                disabled={!params.inputProps.value}
                                onClick={() => {
                                  const value = params.inputProps.value;
                                  handleText({
                                    target: { name: "customerId", value },
                                  });
                                }}
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>

                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              )}
            </Grid>
            <Grid item sm={4}>
              <CustomTextfeild
                type={"text"}
                error={error.numberOfDevices}
                label={t("CUSTDATABLE33")}
                name={"numberOfDevices"}
                required={true}
                value={configurationPayload.numberOfDevices || ""}
                validation={"restrictNumericValueToTenDigits"}
                handleChange={(e) => handleKeyFieldChange(e)}
              />
            </Grid>
          </Grid>
          <Grid
            container
            style={{
              paddingLeft: "20px",
            }}
          >
            <Typography
              style={{
                fontSize: "20px",
                fontFamily: "font_semiBold",
                fontWeight: 700,
                color: "#3D4977",
              }}
            >
              {t("KEYCONFIGURATIONANDROIDKEYHEADER")}
            </Typography>
          </Grid>
          <Grid
            container
            spacing={2}
            style={{
              padding: "20px",
              width: "100%",
            }}
          >
            <Grid item sm={4}>
              <CustomTextfeild
                type={"text"}
                value={configurationPayload.privateConstValScannerKey}
                error={error.privateConstValScannerKey}
                label={t("KEYCONFIGURATIONIOSKEYPDF")}
                name={"privateConstValScannerKey"}
                required={true}
                handleChange={(e) => handleKeyFieldChange(e)}
              />
            </Grid>
            <Grid item sm={4}>
              <CustomTextfeild
                type={"text"}
                value={configurationPayload.privateConstValParserKey}
                error={error.privateConstValParserKey}
                label={t("KEYCONFIGURATIONIOSKEYPDFPARSER")}
                name={"privateConstValParserKey"}
                required={true}
                handleChange={(e) => handleKeyFieldChange(e)}
              />
            </Grid>
            <Grid item sm={4}>
              <CustomTextfeild
                type={"text"}
                value={configurationPayload.androidMRZDetectionActivationKey}
                error={error.androidMRZDetectionActivationKey}
                label={t("KEYCONFIGURATIONIOSKEYMRZ")}
                name={"androidMRZDetectionActivationKey"}
                required={true}
                handleChange={(e) => handleKeyFieldChange(e)}
              />
            </Grid>
          </Grid>
          <Grid
            container
            style={{
              paddingLeft: "20px",
            }}
          >
            <Typography
              style={{
                fontSize: "20px",
                fontFamily: "font_semiBold",
                fontWeight: 700,
                color: "#3D4977",
              }}
            >
              {t("KEYCONFIGURATIONIOSKEYHEADER")}
            </Typography>
          </Grid>
          <Grid
            container
            spacing={2}
            style={{
              padding: "20px",
              width: "100%",
            }}
          >
            <Grid item sm={4}>
              <CustomTextfeild
                type={"text"}
                value={configurationPayload.pdfDetectorActivationKey}
                error={error.pdfDetectorActivationKey}
                label={t("KEYCONFIGURATIONIOSKEYPDF")}
                name={"pdfDetectorActivationKey"}
                required={true}
                handleChange={(e) => handleKeyFieldChange(e)}
              />
            </Grid>
            <Grid item sm={4}>
              <CustomTextfeild
                type={"text"}
                error={error.pdfParserActivationKey}
                value={configurationPayload.pdfParserActivationKey}
                label={t("KEYCONFIGURATIONIOSKEYPDFPARSER")}
                name={"pdfParserActivationKey"}
                required={true}
                handleChange={(e) => handleKeyFieldChange(e)}
                helperText={error.name}
              />
            </Grid>
            <Grid item sm={4}>
              <CustomTextfeild
                type={"text"}
                value={configurationPayload.mrzDetectorActivationKey}
                error={error.mrzDetectorActivationKey}
                label={t("KEYCONFIGURATIONIOSKEYMRZ")}
                name={"mrzDetectorActivationKey"}
                required={true}
                handleChange={(e) => handleKeyFieldChange(e)}
              />
            </Grid>
          </Grid>
        </Box>
        <Grid
          container
          spacing={2}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "10px",
            paddingRight: "38px",
          }}
        >
          <Grid item>
            <CancelButtons
              onClick={handleCancel}
              color="secondary"
              variant="contained"
            >
              <Typography>{t("COMMON008")}</Typography>
            </CancelButtons>
          </Grid>
          <Grid item>
            <SubmitButtons onClick={handleSubmit} variant="contained">
              <Typography>{t("COMMON007")}</Typography>
            </SubmitButtons>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}
